'use client'

import dynamic from 'next/dynamic'

import { SEARCH_PARAM_KEYS as AUTH_SEARCH_PARAM_KEYS } from '@/constants/auth'
import { useUAContext } from '@/context/UAContext'
import { useShareComponentBaseConfig } from '@/hooks/useShareComponentBaseConfig'
import { useShareComponentProfile } from '@/hooks/useShareComponentProfile'
import { useSearchParams } from 'next/navigation'

const ShareComponentFooter = dynamic(() =>
  import('@viveportengineering/share-component').then((mod) => mod.Footer),
)

export default function FooterClient() {
  const searchParams = useSearchParams()
  const profile = useShareComponentProfile()
  const previewMode = searchParams.has(AUTH_SEARCH_PARAM_KEYS.PREVIEW)
  const { isMobileApp } = useUAContext()

  const { authConfig, localeConfig, originConfig } = useShareComponentBaseConfig({
    previewMode,
    profile,
  })

  return (
    <ShareComponentFooter
      key={localeConfig.locale}
      authConfig={authConfig}
      localeConfig={localeConfig}
      origin={originConfig}
      isMobileApp={isMobileApp}
    />
  )
}
